var map = {
	"./200.png": 8079,
	"./250.png": 2824,
	"./251.png": 3041,
	"./252.png": 1930,
	"./3.jpg": 6450,
	"./4.jpg": 1681,
	"./7.jpg": 5830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2525;